import { z } from 'zod';

import { CustomerVehicleResponseSchema } from './customer-vehicle.schemas.js';

export const FindVehicleByPlateQuerySchema = z.object({
  plate: z.string().trim().min(1),
});

export type FindVehicleByPlateQuery = z.infer<typeof FindVehicleByPlateQuerySchema>;

export const FindVehicleByPlateResponseSchema = z.object({
  vehicle: CustomerVehicleResponseSchema,
  /** COALESCE(tradeName, legalName, name) — quick panel only. */
  partyDisplayName: z.string().nullable(),
});

export type FindVehicleByPlateResponse = z.infer<typeof FindVehicleByPlateResponseSchema>;
